import Select from "react-select";
import { TitleBar } from "./TitleBar";
import apiAgent from "../api/apiAgent";
import { useEffect, useState } from "react";
import { IDropdownOption } from "../utils/customisation";
import { DisplayValue } from "./DisplayValue";
import _ from "lodash";

const fetchFilters = async (
  setOptions: React.Dispatch<React.SetStateAction<IDropdownOption[]>>,
) => {
  try {
    const response = await apiAgent.DataType.getAll("tags");
    if (response.status === 200) {
      setOptions(
        response.data.map((filter: any) => {
          return {
            value: filter.id,
            label: filter.name,
          };
        }),
      );
    }
  } catch (err) {
    console.log(err);
  }
};

export const FilterSelector = ({
  currentFilters,
  updateFiltersFn,
}: {
  currentFilters: number[];
  updateFiltersFn: (ids: number[]) => void;
}): JSX.Element => {
  const [options, setOptions] = useState<IDropdownOption[]>([]);

  useEffect(() => {
    fetchFilters(setOptions);
  }, []);

  const handleChange = (e: any) => {
    // console.log(e);
    // update filters here
    const valuesToSend = e.map((option: IDropdownOption) => option.value);
    updateFiltersFn(valuesToSend);
  };

  const selectedFilters = currentFilters.map((filterId) => {
    const findFromOptions = options.find((o) => o.value === filterId);
    return (
      findFromOptions || {
        label: "Unknown filter",
        value: -1,
      }
    );
  });

  return (
    <div className="my-8">
      <TitleBar title="Filters" />
      <Select
        options={options}
        onChange={handleChange}
        value={selectedFilters}
        isMulti
        placeholder="Add a filter"
      />
    </div>
  );
};

export const FilterDisplay = ({
  currentFilters,
}: {
  currentFilters: number[];
}): JSX.Element => {
  const [filters, setFilters] = useState<IDropdownOption[]>([]);

  useEffect(() => {
    fetchFilters(setFilters);
  }, []);

  const filterArray = filters.reduce(
    (arr: string[], filter: IDropdownOption) => {
      const label = _.toString(filter.label || filter.value);
      return _.includes(currentFilters, filter.value) ? [...arr, label] : arr;
    },
    [],
  );

  const displayString = _.toString(filterArray).replaceAll(",", ", ");

  return <DisplayValue name="Filter Tags" value={displayString} />;
};
